package com.tixforgigs.common.core.extensions

val Any?.isNull get() = this == null
val Any?.isNotNull get() = this != null

inline fun <T> T?.orElse(fallback: () -> T): T = this ?: fallback()

inline fun <A, B, R> ifAllNotNull(
  a: A?, b: B?, block: (A, B) -> R
): R? = if (a != null && b != null) block(a, b) else null

inline fun <A, B, C, R> ifAllNotNull(
  a: A?, b: B?, c: C?, block: (A, B, C) -> R
): R? = if (a != null && b != null && c != null) block(a, b, c) else null
